module.exports = __webpack_public_path__ + "img/mpcbuilding_img.702230bc.png";